// =============================================================================
// Copyright   : 2019 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Olli Powroznik, Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : widget utils
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {Sel} from 'uix/registries'
import {Link} from 'uix/components'
import {windowDevicePixelRatio} from 'uix/utils'
import {useSelector} from 'uix/hooks'

export const wcUrl = (apiurl, width, otid) => apiurl.href(`/download/webcache/${width}/${otid}`)

export const ViewerLink = ({children, ...props}) => {
  // hack munich demo
  //~ let apiurl = useSelector(Sel.apiurl)
  //~ let path = apiurl.href(`/dms/content/zoom/${props.id}`)
  //~ return (
  //~ <Link path={path} target={null}>
  //~ {children}
  //~ </Link>
  //~ )

  return (
    <Link tabname="viewer" {...props}>
      {children}
    </Link>
  )
}

let staticWebcacheWidth = width => {
  /* assume we have at least 128, 304, 504, 1000
   */
  width = width * windowDevicePixelRatio
  if (width <= 128) {
    return 128
  } else if (width <= 304) {
    return 304
  } else if (width <= 504) {
    return 504
  } else {
    return 1000
  }
}

export const fitWebcacheImage = ({aspectRatio, pageWidth, pageHeight, width, height}) => {
  /* fit a rectangular image given by aspectRatio or (pageWidth, pageHeight)
  into a screen rectangle given by width and or height
  */
  if (!aspectRatio) {
    aspectRatio = pageWidth / pageHeight
  }

  let res = {width, height}
  if (width && height) {
    // target rect is width and height limited
    let fitToWidth = width / aspectRatio < height
    if (fitToWidth) {
      res.height = width / aspectRatio
    } else {
      res.width = height * aspectRatio
    }
  } else if (width) {
    // target rect is only width limited
    res.height = width / aspectRatio
  } else if (height) {
    // target rect is only height limited
    res.width = height * aspectRatio
  }
  res.wcWidth = staticWebcacheWidth(res.width)
  return res
}
